export const LANGS = {
    en: 'en',
    fr: 'fr'
}